export const initializeRadioButtons = cb => {
  const allowUncheckItems = document.querySelectorAll('.js-allowRadioUncheck');
  const checkedArray = [];

  allowUncheckItems.forEach((item, index) => {
    checkedArray[index] = false;

    item.addEventListener('click', function(e) {
      // Toggle the checked state
      if (checkedArray[index]) {
        this.checked = false;
        checkedArray[index] = false;
      } else {
        checkedArray[index] = true;
      }

      // Update other radio buttons' checked state
      checkedArray.forEach((_, i) => {
        if (i !== index) checkedArray[i] = false;
      });

      // Manually dispatch the 'change' event
      const changeEvent = new Event('change', { bubbles: true });
      this.dispatchEvent(changeEvent);
    });
  });

  document.querySelectorAll('.js-allowRadioUncheck').forEach(item => {
    item.addEventListener('change', function(e) {
      cb && cb();
    });
  });
}